import { Address } from './Order'

export enum PaymentCardBrands {
  VISA = 'Visa',
  AMERICAN_EXPRESS = 'American Express',
  DISCOVER = 'Discover',
  MASTER_CARD = 'MasterCard',
}

export type Client = {
  clientId: string
  firstName: string
  lastName: string
  phoneNumber: string
  email: string
  shippingAddress: Address
  billingAddress: Address
  loyaltyProgram: LoyaltyProgram
  orderAbstract?: any
  paymentCard?: {
    last4Digits: string
    holderName: string
    paymentCardToken?: string
    brand: PaymentCardBrands
    expirationYear: number
    expirationMonth: number
  }
  promotionalCredits?: number
  shopifyCustomerId?: string
}

export enum LoyaltyProgram {
  YOTPO = 'YOTPO',
  NONE = 'NONE',
}
